"use strict";
var capacitor_1 = require('./capacitor');
var range = require('lodash.range');
var MAX_RECORDS = 10000;
var Pager = (function () {
    function Pager(flux) {
        this.flux = flux;
    }
    Pager.prototype.next = function () {
        return this.switchPage(this.nextPage);
    };
    Pager.prototype.prev = function () {
        return this.switchPage(this.previousPage);
    };
    Pager.prototype.last = function () {
        return this.switchPage(this.finalPage);
    };
    Pager.prototype.reset = function () {
        return this.switchPage(this.firstPage);
    };
    Object.defineProperty(Pager.prototype, "currentPage", {
        get: function () {
            return this.getPage(this.fromResult);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pager.prototype, "previousPage", {
        get: function () {
            return (this.currentPage - 1 >= this.firstPage) ? this.currentPage - 1 : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pager.prototype, "nextPage", {
        get: function () {
            return (this.currentPage + 1 <= this.finalPage) ? this.currentPage + 1 : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pager.prototype, "firstPage", {
        get: function () {
            return 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pager.prototype, "finalPage", {
        get: function () {
            return Math.max(this.getPage(this.restrictTotalRecords(this.totalRecords, this.pageSize)), 1);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pager.prototype, "fromResult", {
        get: function () {
            return this.flux.query.build().skip + 1 || 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pager.prototype, "toResult", {
        get: function () {
            if ((this.currentPage * this.pageSize) > this.totalRecords) {
                return ((this.currentPage - 1) * this.pageSize) + (this.totalRecords % this.currentPage);
            }
            else {
                return this.currentPage * this.pageSize;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Pager.prototype, "totalRecords", {
        get: function () {
            return this.flux.results ? this.flux.results.totalRecordCount : 0;
        },
        enumerable: true,
        configurable: true
    });
    Pager.prototype.pageExists = function (page) {
        return page <= this.finalPage && page >= this.firstPage;
    };
    Pager.prototype.pageNumbers = function (limit) {
        if (limit === void 0) { limit = 5; }
        return range(1, Math.min(this.finalPage + 1, limit + 1))
            .map(this.transformPages(limit));
    };
    Pager.prototype.switchPage = function (page) {
        if (this.pageExists(page)) {
            var skip = (page - 1) * this.pageSize;
            this.flux.query.skip(skip);
            this.flux.emit(capacitor_1.Events.PAGE_CHANGED, { pageNumber: page });
            return this.flux.search();
        }
        else {
            return Promise.reject(new Error("page " + page + " does not exist"));
        }
    };
    Pager.prototype.restrictTotalRecords = function (total, pageSize) {
        if (total > MAX_RECORDS) {
            return MAX_RECORDS - (MAX_RECORDS % pageSize);
        }
        else if ((total + pageSize) > MAX_RECORDS) {
            if (MAX_RECORDS % pageSize === 0) {
                return MAX_RECORDS;
            }
            else {
                return total - (total % pageSize);
            }
        }
        else {
            return total;
        }
    };
    Pager.prototype.getPage = function (record) {
        return Math.ceil(record / this.pageSize);
    };
    Pager.prototype.transformPages = function (limit) {
        var _this = this;
        var border = Math.ceil(limit / 2);
        return function (value) {
            // account for 0-indexed pages
            if (_this.currentPage <= border || limit > _this.finalPage) {
                // pages start at beginning
                return value;
            }
            else if (_this.currentPage > _this.finalPage - border) {
                // pages start and end in the middle
                return value + _this.finalPage - limit;
            }
            else {
                // pages end at last page
                return value + _this.currentPage - border;
            }
        };
    };
    Object.defineProperty(Pager.prototype, "pageSize", {
        get: function () {
            return this.flux.query.build().pageSize || 10;
        },
        enumerable: true,
        configurable: true
    });
    return Pager;
}());
exports.Pager = Pager;



//////////////////
// WEBPACK FOOTER
// ./~/groupby-api/dist/src/flux/pager.js
// module id = 164
// module chunks = 0